import styled from '@emotion/styled'

export const StyledModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(max(100vh));
  min-width: calc(max(100vw));
  z-index: 10001;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  margin: auto;
  display: block;
`
